import { JL } from 'jsnlog';
import { LandingComponent } from './../../landing/landing.component';
import { Issue } from './issue';
import { CivilCase } from './../civil-case';
import { SafeJSON } from './../../shared/safe-json';


export class PreJaabstracts {
    private json: any;
    private key: string;
    private payoffCalculationsShowFlag: boolean[];

    constructor(json: any, key: string) {
        this.json = json;
        this.key = key;
        // Yes, code=’A’ is the debtor and code =’B’ is the creditor.
        const abstractParties: any[] = this.getAbstractPartiesUnsortedList('A');
        if (abstractParties.length !== 0) {
            this.payoffCalculationsShowFlag = new Array((abstractParties.length)).fill(false);
            if (abstractParties.length === 1) {
                this.payoffCalculationsShowFlag[0] = true;  // only one debtor, show the calculations
            }
        } else {
            this.payoffCalculationsShowFlag = new Array((1)).fill(false);  // we need at least one flag set in the array
        }
    }
    getKey(): string {
        return this.key;
    }
    getPreJAAbstractNumber(): string {
        return SafeJSON.get('abstractNumber', this.json);
    }
    getAbstractJudgmentNumber(): string {
       return this.getPreJAAbstractNumber();
    }
    getPreJAJudgmentAmount(civilCase: CivilCase): Number {
        return SafeJSON.getNumber('totalPrincipal', this.json);
    }
    getPreJAAbstractRef(civilCase: CivilCase, abstractRef: string): string {
        const prejJAIssueRef = SafeJSON.get('issueRef', this.json);
        const issue: Issue = civilCase.getIssueListByKey(prejJAIssueRef);
        const issueAbstractRef = issue.getAbstractRefKey();
        if (issueAbstractRef === abstractRef) {
            return abstractRef;
        }
        return '';
    }
    // Wilson - 1997CR3038  preJA
    getPreJAInterestRate(civilCase: CivilCase): string {
        return this.getPercentageWithFormatting('judgmentSummary.interestRate', this.json);
    }
    getPercentageWithFormatting(jsonField: string, json: string): string {
        const rateString: string = (SafeJSON.get(jsonField, json)).toString();
        const rate = SafeJSON.getNumber(jsonField, json) * 100;
        if (rateString.length > 0) {
            return rate.toPrecision(rateString.length - 1);
        }
        return rateString;
    }
    getIsPreJAPartiallyAbstracted(): boolean {
        const code = SafeJSON.get('judgmentSummary.judgmentSummaryAbstractStatusCode.code', this.json);
        if (code === 'PART') {
            return true;
        }
        return false;
    }
    getIsPreJAFullyAbstracted(): boolean {
        const code = SafeJSON.get('judgmentSummary.judgmentSummaryAbstractStatusCode.code', this.json);
        if (code === 'FULL') {
            return true;
        }
        return false;
    }
    getPreJAAmountOwed(): Number {
        return SafeJSON.get('totalBalance', this.json);
    }
    getPreJAjudgmentTransactionList(civilCase: CivilCase, abstractRef: string): any[] {
        const judgmentTransactionList: any[] = SafeJSON.get('judgmentSummary.judgmentTransactionList', this.json);

        return judgmentTransactionList.sort( function(p1, p2) {
            const result = p1.effectiveDate.localeCompare(p2.effectiveDate);
            if (result !== 0) {
                return result;
            }
            // Dates are the same so look at the type (nested sort)
            return p1.transactionType.description.localeCompare(p2.transactionType.description);
        });
    }
    getPreJAAmount(transaction: string): Number {
        return SafeJSON.getNumber('amount', transaction);
    }
    // Wilson - 1997CR3038  preJA
    getPreJAAmountInterest(transaction: string): string {
        return this.getPercentageWithFormatting('amount', transaction);
    }
    getPreJAEffectiveDate(transaction: string): string {
        return SafeJSON.get('effectiveDate', transaction);
    }
    getPreJATransactionType(transaction: string): string {
        return SafeJSON.get('transactionType.description', transaction);
    }
    getPreJATransactionSource(transaction: string): string {
        return SafeJSON.get('source.description', transaction);
    }
    getPreJAReasonCode(transaction: string): string {
        return SafeJSON.get('reason.description', transaction);
    }
    getPreJAReferenceNumber(transaction: string): string {
        return SafeJSON.get('referenceNumber', transaction);
    }
    getPreJAIssueClockedInDate(civilCase: CivilCase): string {
        const issueRef = SafeJSON.get('issueRef', this.json);
        const issue: Issue = civilCase.getIssueListByKey(issueRef);
        const clockedDate = issue.getPleadingClockedInDate(civilCase);
        return clockedDate;
    }
    getPreJAPleadingTypeDescription(civilCase: CivilCase): string {
        const issueRef = SafeJSON.get('issueRef', this.json);
        const issue: Issue = civilCase.getIssueListByKey(issueRef);
        const text = issue.getPleadingDescription(civilCase);
        return text;
    }
    getPreJAIssueType(civilCase: CivilCase): string {
        const issueRef = SafeJSON.get('issueRef', this.json);
        const issue: Issue = civilCase.getIssueListByKey(issueRef);
        const text = issue.getTypeReplaceOther();
        return text;
    }
    getPreJAAbstractStatus(): string {
        return SafeJSON.get('abstractStatus', this.json);
    }
    getPreJAClockedInOnDate(): string {
        return SafeJSON.get('clockDate', this.json);
    }
    getPreJAAbstractStatusDate(): string {
        return SafeJSON.get('cancelDate', this.json);
    }
    getPreJAAbstractCancelReasonCodeDescription(): string {
        let reason = SafeJSON.get('cancelReason.description', this.json);
        if (reason !== '') {
            reason = ', ' + reason;
        }
        return reason;
    }
    getPreJAPartialAbstract(civilCase: CivilCase): string {
        const SPECIALBOOKPAGE8S = '888';
        const SPECIALBOOKPAGE9S = '999';
        const seeClerkText = 'Please see clerk for complete details.';
        const orderList: any[] = civilCase.getOrderList();

        if (this.getIsPreJAPartiallyAbstracted()) {
            for (let i = 0; i < orderList.length; i++) {
                let issueKey = SafeJSON.get('issueKey', orderList[i].json);
                if (issueKey === this.json.issueRef) {

                    const docketBookNum = SafeJSON.get('docketBookNum', orderList[i].json);
                    const docketPageNum = SafeJSON.get('docketPageNum', orderList[i].json);
                    if (docketBookNum === '') {
                        return seeClerkText;
                    }
                    if (docketBookNum === SPECIALBOOKPAGE8S || docketBookNum === SPECIALBOOKPAGE9S) {
                        return seeClerkText;
                    }
                    return ' See book ' + docketBookNum + ', page ' + docketPageNum + '.';
                }
            }
        }
        return seeClerkText;
    }
    ////////////////////////////////////////////////////////////////////////////
    getPreJAPayoffCalculatorDailyInterestMessage(abstractParty: any): string {
        let dailyInterestAmount = this.getPreJAPayoffDailyInterest(abstractParty);
        const text = this.getPayoffCompoundInterestMessage(abstractParty);
        if (text !== '') {
            return text;
        }
        // if there are no interval interest rates, then just use the daily interest for the payoff.
        return 'Interest accrues at $' + dailyInterestAmount + ' per day.';
    }
    getPreJAShowPayoffInterestMessage(abstractParty: any): boolean {
        if (this.getPreJAPayoffDailyInterest(abstractParty) === null
            || this.getPreJAPayoffDailyInterest(abstractParty) === 0) {
            return false;
            }
        return true;
    }
    getPreJAPayoffDailyInterest(abstractParty: any): number {
        return SafeJSON.getNumber('dailyInterest', this.json);
    }
    // Ordered
    getPayoffCalculatorOrderedMoneyAward(abstractParty: any): Number {
        return SafeJSON.getNumber('totalPrincipal', this.json);
    }
    getPayoffCalculatorOrderedInterest(abstractParty: any): Number {
        return SafeJSON.getNumber('totalInterest', this.json);
    }
    getPayoffCalculatorOrderedTotal(abstractParty: any): Number {
        return SafeJSON.getNumber('totalAmount', this.json);
    }
    // Paid
    getPayoffCalculatorPaidMoneyAward(abstractParty: any): number {
        let num: number = SafeJSON.getNumber('totalPrincipalPaid', this.json);
        return this.convertToNegativeNumber(num);
    }
    getPayoffCalculatorPaidInterest(abstractParty: any): Number {
        return this.convertToNegativeNumber(SafeJSON.getNumber('totalInterestPaid', this.json));
    }
    getPayoffCalculatorPaidCostsAndFees(abstractParty: any): Number {
        return this.convertToNegativeNumber(SafeJSON.getNumber('totalCostPaid', this.json));
    }
    getPayoffCalculatorPaidTotal(abstractParty: any): Number {
        return this.convertToNegativeNumber(SafeJSON.getNumber('totalPaid', this.json));
    }
    // Balance
    getPayoffCalculatorBalanceMoneyAward(abstractParty: any): Number {
        return SafeJSON.getNumber('principalBalance', this.json);
    }
    getPayoffCalculatorBalanceInterest(abstractParty: any): Number {
        return SafeJSON.getNumber('interestBalance', this.json);
    }
    getPayoffCalculatorBalanceCostsAndFees(abstractParty: any): Number {
        return SafeJSON.getNumber('costBalance', this.json);
    }
    getPayoffCalculatorBalanceTotal(abstractParty: any): Number {
        return SafeJSON.getNumber('totalBalance', this.json);
    }
    getPayoffCalculatedDate(): string {
        return SafeJSON.get('payoffCalculatedOnDate', this.json);
    }
    getPayoffCalculatorMaxLiabiltyMoneyAward(abstractParty: any): Number {
        return SafeJSON.getNumber('totalPrincipal', this.json);
    }
    getPayoffCalculatorMaxLiabiltyCostsAndFees(abstractParty: any): Number {
        return SafeJSON.getNumber('totalPrincipal', this.json);
    }
    getPayoffCalculatorMaxLiabiltyInterest(abstractParty: any): Number {
        return SafeJSON.getNumber('totalPrincipal', this.json);
    }
    getPayoffCalculatorMaxLiabiltyTotal(abstractParty: any): Number {
        return SafeJSON.getNumber('totalPrincipal', this.json);
    }
    returnIfNotEmpty(source: string, displayString: string): string {
        if (source === '' || source === '-') {
            return '';
        }
        return displayString;
    }
    showPreJAPayoffCalculation(i: number) {
        this.payoffCalculationsShowFlag[i] = true;
    }
    hidePreJAPayoffCalculation(i: number) {
        this.payoffCalculationsShowFlag[i] = false;
    }
    getPreJAPayoffCalculationsShowFlag(i: number): boolean {
        return this.payoffCalculationsShowFlag[i];
    }
    public getAffectedParty(civilCase: CivilCase, abstractParty: any): string {
        const casePartyRef = SafeJSON.getWithDefault('casePartyRef', abstractParty.json);
        const partyName = civilCase.getPartyNameByPartyRef(casePartyRef);
        const partyRole = civilCase.getPartyDescriptionByPartyRef(casePartyRef);
        const partyNumber = civilCase.getPartyNumberByPartyRef(casePartyRef);
        return partyName + ' (' + partyRole + ' ' + partyNumber + ')';
    }
    getAbstractParties(): any {
        return SafeJSON.get('issueOrderPartyRef', this.json);
    }
    // No need to sort this list, we just want the length of the list
    getAbstractPartiesUnsortedList(type: string): any[] {
        const abstractPartiesMap = this.getAbstractParties();
        const map = new Map();

        Object.keys(abstractPartiesMap).forEach(key => {
            const value = new Issue(abstractPartiesMap[key], key);
            map.set(key, value);
        });
        let abstractPartiesList: any[] = Array.from(map.values());
        return abstractPartiesList.filter(list2 => list2.json.issueOrderPartyRole.code === type);
    }
    // This needs to match the sister method in abstract.ts
    getAbstractPartiesList(civilCase: CivilCase, type: string): any[] {
        const abstractPartiesMap = this.getAbstractParties();
        const map = new Map();

        Object.keys(abstractPartiesMap).forEach(key => {
            const value = new Issue(abstractPartiesMap[key], key);
            map.set(key, value);
        });
        let abstractPartiesList: any[] = Array.from(map.values());
        abstractPartiesList = abstractPartiesList.filter(list2 => list2.json.issueOrderPartyRole.code === type);
        /*
            UX319	Based on the case type, parties will be sorted by party role in the specified order and then by party sequence number in
            ascending numerical order within each party role. Party roles will be sorted as follows:

            Getting here means we have the list of Debtors or Creditors.  The parties can be mixed
            so we can have casePartyRefs of D1, P1, D2, D3, P4.  It needs be to sorted
            as D1, D2, D3, P1, P4 for example.
        */
       let caseType = civilCase.getCaseType();
       let partyList: any[] = [];
       if (caseType === 'CR' || caseType === 'CRS' || caseType === 'J') {
           return partyList
           .concat( this.getSortedAbstractPartyListByRoleCodeFromList(abstractPartiesList, 'P'))
           .concat( this.getSortedAbstractPartyListByRoleCodeFromList(abstractPartiesList, 'D'))
           .concat( this.getSortedAbstractPartyListByRoleCodeFromList(abstractPartiesList, 'F'))
           .concat( this.getSortedAbstractPartyListByRoleCodeFromList(abstractPartiesList, 'S'))
       }
       if (caseType === 'E' || caseType === 'EO') {
           return partyList
           .concat( this.getSortedAbstractPartyListByRoleCodeFromList(abstractPartiesList, 'E'))
           .concat( this.getSortedAbstractPartyListByRoleCodeFromList(abstractPartiesList, 'F'))
           .concat( this.getSortedAbstractPartyListByRoleCodeFromList(abstractPartiesList, 'B'))
       }
       if (caseType === 'SP') {
           return partyList
           .concat( this.getSortedAbstractPartyListByRoleCodeFromList(abstractPartiesList, 'P'))
           .concat( this.getSortedAbstractPartyListByRoleCodeFromList(abstractPartiesList, 'F'))
           .concat( this.getSortedAbstractPartyListByRoleCodeFromList(abstractPartiesList, 'R'))
           .concat( this.getSortedAbstractPartyListByRoleCodeFromList(abstractPartiesList, 'D'))
           .concat( this.getSortedAbstractPartyListByRoleCodeFromList(abstractPartiesList, 'S'))
       }
       if (caseType === 'R') {
           return partyList
           .concat( this.getSortedAbstractPartyListByRoleCodeFromList(abstractPartiesList, 'P'))
           .concat( this.getSortedAbstractPartyListByRoleCodeFromList(abstractPartiesList, 'R'))
       }
       if (caseType === 'M') {
           return partyList
           .concat( this.getSortedAbstractPartyListByRoleCodeFromList(abstractPartiesList, 'P'))
           .concat( this.getSortedAbstractPartyListByRoleCodeFromList(abstractPartiesList, 'D'))
           .concat( this.getSortedAbstractPartyListByRoleCodeFromList(abstractPartiesList, 'E'))
           .concat( this.getSortedAbstractPartyListByRoleCodeFromList(abstractPartiesList, 'R'))
           .concat( this.getSortedAbstractPartyListByRoleCodeFromList(abstractPartiesList, 'S'))
       }
       if (caseType !== 'CVM' && caseType !== 'CVD' && caseType !== 'CVS') {
           // getting here would be an error condition.
           this.logToConsoleAndServer('getAbstractPartiesList: caseType=' + caseType +
                                ', error - case type not recognized! Using the party list we received from WS.');
       }
       // by default use the CVM ordering
       return partyList
           .concat( this.getSortedAbstractPartyListByRoleCodeFromList(abstractPartiesList, 'P'))
           .concat( this.getSortedAbstractPartyListByRoleCodeFromList(abstractPartiesList, 'D'))
           .concat( this.getSortedAbstractPartyListByRoleCodeFromList(abstractPartiesList, 'I'))
   }
   getSortedAbstractPartyListByRoleCodeFromList(abstractPartiesList: any[], roleCode: string): any[] {
       abstractPartiesList = abstractPartiesList.filter(abstractParty =>
        abstractParty.json.casePartyRef.substring(0, 1) === roleCode);

       abstractPartiesList
           .sort( function(p1, p2) {
            const casePartyRef1 = p1.json.casePartyRef;
            let cpr1Number = Number.parseInt(casePartyRef1.slice(1, casePartyRef1.length));

            const casePartyRef2 = p2.json.casePartyRef;
            let cpr2Number = Number.parseInt(casePartyRef2.slice(1, casePartyRef2.length));
            return cpr1Number - cpr2Number;
           })
       ;
       return abstractPartiesList;
   }
    getAfffectedPartyStatus(civilCase: CivilCase, abstractParty: any): string {
        const abstractPartyStatus = SafeJSON.getWithDefault('abstractPartyStatus.description', abstractParty.json);
        const abstractPartyStatusCode = SafeJSON.getWithDefault('abstractPartyStatus.code', abstractParty.json);
        const date = '';
        if (abstractPartyStatusCode === 'CNCL') {
            return 'CANCELLED';
        }
        if (abstractPartyStatusCode === 'VACT') {
            return 'VACATED';
        }
        return 'ACTIVE';
    }
    getMoneyDetailList(): any[] {
        const list = this.getListOrEmptyArray('abstractMoneyDetailsList');
        list.sort( function(p1, p2) {
            return p1.detailNumber.localeCompare(p2.detailNumber);
        });
        return list;
    }
    getPayoffCompoundInterestMessage(abstractParty: any): string {
        const moneyList: any[] = this.getMoneyDetailList();
        let simpleInterestRateCount = 0;
        let compoundInterestRatesCount = 0;
        let compoundInterestRate = 0;
        let savedCompoundInterestRate = -1;

        for (let i = 0; i < moneyList.length; i++) {

            const intervalList: any[]  = SafeJSON.get('intervalList', moneyList[i]);
            for (let j = 0; j < intervalList.length; j++) {
                const compoundInterestDescription = this.getSimpleCompoundIndicator(intervalList[j]);
                if (compoundInterestDescription === 'SIMPLE') {
                    simpleInterestRateCount++;
                }
                if (compoundInterestDescription === 'COMPOUND') {
                    compoundInterestRate = SafeJSON.getWithDefault('interestRate', intervalList[j]);
                    if (savedCompoundInterestRate === -1) {
                        savedCompoundInterestRate = compoundInterestRate;
                        compoundInterestRatesCount = 1;
                    } else {
                        if (savedCompoundInterestRate !== compoundInterestRate) {
                            compoundInterestRatesCount++;
                        }
                    }
                }
            }
        }
        // console.log('compoundInterestRateCount=' + compoundInterestRatesCount + ',
        // simpleInterestRateCount=' + simpleInterestRateCount);
        if (compoundInterestRatesCount === 1 && simpleInterestRateCount === 0) {
            compoundInterestRate = compoundInterestRate * 100;
            return 'Interest accrues at ' + compoundInterestRate  + '% compounded daily.';
        }
        if (compoundInterestRatesCount > 0) {
            return 'See clerk for interest calculation.';
        }
        return '';
    }
    getSimpleCompoundIndicator(interval: any): string {
        return SafeJSON.getWithDefault('simpleCompoundIndicator.description', interval);
    }
    getAfffectedPartyCancelDateIfPresent(civilCase: CivilCase, abstractParty: any): string {
        const abstractPartyStatus = SafeJSON.getWithDefault('abstractPartyStatus', abstractParty.json);
        let date = '';
        if (abstractPartyStatus.code === 'CNCL') {
            date = SafeJSON.get('cancelDate', abstractParty.json);
        }
        if (abstractPartyStatus.code === 'VACT') {
            date = SafeJSON.get('vacatedDate', abstractParty.json);
        }
        return date;
    }
    /////////////////////////////////////////////////////////////////////////
    getListOrEmptyArray(id: string): any[] {
        const list = SafeJSON.get(id, this.json);
        if (list === '') {
            return [{}];
        }
        return Array.from(list.values());
    }
    convertToNegativeNumber(num: number): number {
        if (num > 0) {
            num = num * -1;
        }
        return num;
    }
    logToConsoleAndServer(text: string) {
        JL().error(text);
        console.log(text);
    }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/civil/civil-case-sections/pre-jaabstracts.ts